export class EmployeeTrainingReqDto {
    trainingId?: number;
    trainingTitle: string;
    dateOfTraining: string;
    faculty: string;
    duration: string;
    topicCovered: string;
    employeeCode: string;
    employeeName: string;
    isActive: boolean;
    createdUser?: string;
    updatedUser?: string;
    plant?:string

    constructor(trainingId: number, trainingTitle: string, dateOfTraining: string, faculty: string, duration: string,
        topicCovered: string, employeeCode: string, employeeName: string, isActive: boolean,
        createdUser?: string, updatedUser?: string,plant?:string) {
        this.trainingId = trainingId;
        this.trainingTitle = trainingTitle;
        this.dateOfTraining = dateOfTraining;
        this.faculty = faculty;
        this.duration = duration;
        this.topicCovered = topicCovered;
        this.employeeCode = employeeCode;
        this.employeeName = employeeName;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.plant = plant
    }
}